import { useLang } from "@/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = Array(6).fill(t.marquee);
  return (
    <div className="overflow-hidden bg-[#EFECE6] py-6 border-y border-black/5" data-testid="editorial-marquee">
      <div className="marquee-track">
        {[...items, ...items].map((txt, i) => (
          <span key={i} className="font-serif-d italic text-2xl md:text-4xl text-[#2E5A3B] whitespace-nowrap px-8">
            {txt} <span className="not-italic text-[#C86A4B] px-4">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
};
